import dynamic from 'next/dynamic'

export * from './Image'
export * from './ActiveLink'
export * from './ComingSoon'
export * from './MediaGallery'
export * from './CoreValueItem'
export * from './AvailableRoleList'
export * as Vacancy from './Vacancy'

export const Header = dynamic(() => import('./Header'), { ssr: false })
export const Footer = dynamic(() => import('./Footer'), { ssr: false })
export const ProgressBar = dynamic(() => import('./ProgressBar'), { ssr: false })
